import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import Typography from '@mui/material/Typography';


const CountryField = ({ source = 'country' }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	if (!record) {
		return null;
	}

	const value = record[source];

	if (!value) {
		return null;
	}

	const choices = {
		'BE': translate('Belgium'),
		'BR': translate('Brazil'),
		'DE': translate('Germany'),
		'FR': translate('France'),
		'NL': translate('Netherlands'),
	};

	return (
		<Typography variant="body2">{choices[value]}</Typography>
	);
};

export default CountryField;
